// import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { GoogleOAuthProvider } from '@react-oauth/google';

import App from './App.tsx';
import { StateProvider } from './store/stateContext.tsx';

const initWidget = () => {
  addLinks();
  // Create a div with id widget and append to the existing body
  const widget = document.createElement('div');
  widget.id = 'widget';
  document.body.appendChild(widget);
  const scriptTag = document.getElementById('widget_loader');
  const accountId = scriptTag?.getAttribute('data-account-id');
  const widgetId = scriptTag?.getAttribute('data-widget-id');
  const postPurchase = scriptTag?.getAttribute('data-post-purchase');
  const widgetAlignment = scriptTag?.getAttribute('data-widget-alignment');
  console.log('accountId', accountId);
  console.log('widgetId', widgetId, widgetAlignment);
  ReactDOM.createRoot(document.getElementById('widget')!).render(
    <React.StrictMode>
      <StateProvider>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
          <div className='user-pop'>
            <App widgetId={widgetId} isPurchase={postPurchase === 'true' ? true : false} />
          </div>
        </GoogleOAuthProvider>
      </StateProvider>

    </React.StrictMode>,
  )
}
export function addLinks() {
  const links = [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: true },
    { rel: 'stylesheet', href: import.meta.env.VITE_WIDGET_CSS_URL },
    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap' },
  ] as Array<{ rel: string; href: string; crossorigin?: boolean; type?: string }>;

  links.forEach(link => {
    const linkElement = document.createElement('link');
    linkElement.rel = link.rel;
    linkElement.href = link.href;
    if (link.type) linkElement.type = link.type;
    if (link.crossorigin) linkElement.crossOrigin = link.crossorigin.toString();
    document.head.appendChild(linkElement);
  });
  const gtagKey = import.meta.env.VITE_GA_KEY; // Store your Google Analytics key in the environment variable
  if (gtagKey) {
    // Create the Google Analytics script tag
    const scriptTag1 = document.createElement('script');
    scriptTag1.src = `https://www.googletagmanager.com/gtag/js?id=${gtagKey}`;
    scriptTag1.async = true;
    document.head.appendChild(scriptTag1);

    // Create the inline script for initializing gtag
    const scriptTag2 = document.createElement('script');
    scriptTag2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gtagKey}');
    `;
    document.head.appendChild(scriptTag2);
  }
  // Add custom CSS rules
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    #widget {
      font-size: 16px !important;
      line-height: 1.5 !important;
      position: relative !important;
    }
  
    /* Allow overlays to display properly within the widget */
    #widget .form-overlay {
      max-height: none !important;
      overflow: visible !important;
      background-color: rgba(89, 66, 209, 0.6) !important;
      display: flex !important;
      justify-content: flex-end !important;
      flex-direction: column !important;
      z-index: 999999 !important;
    }
  
    /* Position the UserForm container properly within the widget */
    #widget .userform-container {
      position: absolute !important;
      bottom: 0 !important;
      z-index: 10000 !important;
    }
  
    /* Style the button at the bottom */
    #widget form[class*="FormContainer"] button[type="submit"] {
      position: sticky !important;
      bottom: 0 !important;
      width: 100% !important;
      border-radius: 0 !important;
      background-color: rgb(89, 66, 209) !important;
      color: white !important;
      font-weight: bold !important;
      height: 48px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
    }
  `;
  document.head.appendChild(styleElement);
}

if (document.readyState === 'loading') {
  console.log('Dom is still in loading state')
  document.addEventListener('DOMContentLoaded', initWidget);
} else {
  console.log('Dom is already loaded')
  initWidget(); // DOM already loaded
}
